import React from 'react';
import { ctaImage } from '../data/mockData';

const CtaSection = () => {
  return (
    <section className="relative overflow-hidden">
      <div
        className="w-full h-[250px] sm:h-[300px] md:h-[450px] lg:h-[550px] bg-cover bg-center md:bg-fixed"
        style={{
          backgroundImage: `url('${ctaImage}')`,
        }}
      />
    </section>
  );
};

export default CtaSection;
